import { CookingTimeDto } from "services/menu/restModels";
import { SelectOption } from "shared/ui";

const RANGES: [number, number][] = [
    [1, 5],
    [5, 10],
    [10, 20],
    [20, 30],
    [30, 40],
    [40, 50],
    [50, 60],
    [60, 80],
];

const NOT_SET = "";

export const COOKING_TIME_OPTIONS: SelectOption[] = [
    { value: NOT_SET, label: "Не указано" },
    ...RANGES.map(([from, to]) => ({
        value: `${from}-${to}`,
        label: `${from}–${to} мин`,
    })),
];

export const cookingTimeToValue = (cookingTime: CookingTimeDto): string =>
    cookingTime.fromTime == null || cookingTime.toTime == null
        ? NOT_SET
        : `${cookingTime.fromTime}-${cookingTime.toTime}`;

export const valueToCookingTime = (value: string): CookingTimeDto => {
    if (value === NOT_SET) return { fromTime: null, toTime: null };

    const [from, to] = value.split("-");

    return { fromTime: parseInt(from, 10), toTime: parseInt(to, 10) };
};
